module.exports = __webpack_public_path__ + "img/video_cherry.1654d174.jpg";